import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({ 
    token: localStorage.getItem('userToken') || '',
    username: localStorage.getItem('username') || '',
  }),
  getters: {
    isAuthenticated: (state) => !!state.token,
  },
  actions: {
    setlogin(token, username) { 
      this.token = token;
      this.username = username;
      localStorage.setItem('userToken', token);
      localStorage.setItem('username', username);
      localStorage.setItem('authStateChange', Date.now().toString());
    },
    setlogout() {
      this.token = '';
      this.username = '';
      localStorage.removeItem('userToken');
      localStorage.removeItem('username');
      localStorage.setItem('authStateChange', Date.now().toString());
    },
    initCrossTabSync() {
      window.addEventListener('storage', (event) => {
        if (event.key === 'authStateChange') {
          const token = localStorage.getItem('userToken');
          if (!token) {
            this.token = '';
            this.username = '';
            if (window.$router) {
              window.$router.push('/login');
            } else {
              window.location.href = '/login';
            }
          } else {
            this.token = token;
            this.username = localStorage.getItem('username') || '';
          }
        }
      });
    }
  }
});